module.exports = __webpack_public_path__ + "static/HR Smartphone App AbaClik Meine Daten-c17f25179d4c0e4b60adca25549d443a.png";